<div class="rejected-proposal__wrapper">
    <img src='/assets/images/proposal-status/rejected.png'>
  
    <h4 class="rejected-proposal__title">
        Neste momento não temos uma oferta para seu cliente
    </h4>
  </div>
  
  <fd-button [content]="'OK'" (trigger)="navigateToHome()">
  </fd-button>